import axios from 'axios'
import config from '@/helpers/config'
import store from '../../store'

const actions = {
  getProjectByUuid (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.get(
      config.apiUrl + '/projects/by-uuid/' + payload.uuid,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  async getUpcomingInvoiceByCustomerId (context, payload) {
    payload.token = store.getters['auth/currentToken']
    let responses = []
    for (let id = 0; id < payload.stripeSubIds.length; id++) {
      responses.push(await axios.post(config.apiUrl + '/stripe/invoice/upcoming/by-customer', {token: payload.token, organizationUuid: payload.organizationUuid, subscription: payload.stripeSubIds[id]}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }))
    }
    return responses
  },
  async addCard (context, payload) {
    payload.token = store.getters['auth/currentToken']
    let retrieveCustomer = await axios.post(config.apiUrl + '/stripe/customer', { organizationUuid: payload.organizationUuid }, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    if (retrieveCustomer.data.payload === undefined) {
      return axios.post(config.apiUrl + '/stripe/customer/create', {token: payload.token, organizationUuid: payload.organizationUuid, description: payload.description, email: payload.email, source: payload.source}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    } else {
      return axios.post(config.apiUrl + '/stripe/card/add', {token: payload.token, customerId: retrieveCustomer.data.payload.id, source: payload.source}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    }
  },
  async deleteCard (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(config.apiUrl + '/stripe/card/delete', {token: payload.token, customerId: payload.customerId, cardId: payload.cardId}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async setDefaultCard (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(config.apiUrl + '/stripe/card/default', {token: payload.token, customerId: payload.customerId, cardId: payload.cardId}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async createProductandPlan (context, payload) {
    payload.token = store.getters['auth/currentToken']
    let productResponse = await axios.post(config.apiUrl + '/stripe/product/create', {token: payload.token, projectUuid: payload.projectUuid, name: payload.name, description: payload.description}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    let planResponse = await axios.post(config.apiUrl + '/stripe/plan/create', {token: payload.token, projectUuid: payload.projectUuid, planUuid: payload.planUuid, period: payload.period, monthlyFee: payload.monthlyFee, interval: payload.interval, intervalCount: payload.intervalCount, trialPeriodDays: payload.trialPeriodDays, type: payload.type}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    return {productResponse: productResponse, planResponse: planResponse}
  },
  async createPlan (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(config.apiUrl + '/stripe/plan/create', {token: payload.token, projectUuid: payload.projectUuid, planUuid: payload.planUuid, period: payload.period, monthlyFee: payload.monthlyFee, interval: payload.interval, intervalCount: payload.intervalCount, trialPeriodDays: payload.trialPeriodDays, type: payload.type}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async subscribe (context, payload) {
    payload.token = store.getters['auth/currentToken']
    let productResponse = await axios.post(config.apiUrl + '/stripe/product/create', {token: payload.token, projectUuid: payload.projectUuid, name: payload.name, description: payload.description}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    let planResponse = await axios.post(config.apiUrl + '/stripe/plan/create', {token: payload.token, projectUuid: payload.projectUuid, planUuid: payload.planUuid, period: payload.period, monthlyFee: payload.monthlyFee, interval: payload.interval, intervalCount: payload.intervalCount, trialPeriodDays: payload.trialPeriodDays, type: payload.type}, { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
    let productPlanResponse = {productResponse: productResponse, planResponse: planResponse}
    if (productPlanResponse.productResponse.data.status === 'SUCCESS' && productPlanResponse.planResponse.data.status === 'SUCCESS') {
      if (payload.subscriptionId === null) {
        return axios.post(
          config.apiUrl + '/stripe/subscription/create', {token: payload.token, period: payload.period, organizationUuid: payload.organizationUuid, projectUuid: payload.projectUuid, planUuid: payload.planUuid, trialPeriodDays: payload.trialPeriodDays, type: payload.type},
          { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
      } else {
        payload.token = store.getters['auth/currentToken']
        return axios.post(
          config.apiUrl + '/stripe/subscription-item/subscription/create', {token: payload.token, subscriptionId: payload.subscriptionId, projectUuid: payload.projectUuid, planUuid: payload.planUuid, period: payload.period, trialPeriodDays: payload.trialPeriodDays, type: payload.type},
          { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
        )
      }
    }
  },
  retrieveCustomer (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/stripe/customer', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  createCustomer (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/stripe/customer/create', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateCustomer (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.put(
      config.apiUrl + '/stripe/customer/update', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  createSubscription (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/stripe/subscription/create', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  createSubscriptionItem (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/stripe/subscription-item/subscription/create', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateSubscriptionItem (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.put(
      config.apiUrl + '/stripe/subscription-item/subscription/update', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  cancelSubscriptionItem (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/stripe/subscription-item/subscription/' + payload.id, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  cancelSubscription (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/stripe/subscription/cancel/immediately', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  listAllInvoicesByCustomerId (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/stripe/invoice/list/by-customer', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  generateUuid (context, payload) {
    return axios.get(
      config.apiUrl + '/stripe/uuid/generate', { token: store.getters['auth/currentToken'] },
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/stripe.js